import boldDownWardIcon from "../assets/BoldCOLLAPSE CHEVRON.svg";
import greenOutlinedTickMark from "../assets/GreenOutlinedTickMark.png";
import failureOvalIcon from "../assets/Oval.svg";
import PathIcon from "../assets/Path.svg";
import propertyAmenitiesImg from "../assets/PropertyAmenities.png";
import searchGrayIcon from "../assets/SearchGrayIcon.svg";
import circleRightIcon from "../assets/Shape.svg";
import addNewIcon from "../assets/add-new-icon.png";
import appleIcon from "../assets/apple.svg";
import leftLineArrowGreyIcon from "../assets/arrow-left-line-grey.svg";
import leftLineArrowIcon from "../assets/arrow-left-line.svg";
import arrowRightArrowLeftRegular from "../assets/arrow-right-arrow-left-regular.svg";
import arrowRight from "../assets/arrow-right-line BACK.svg";
import arrowNextIcon from "../assets/arrow-right-line copy 2.svg";
import whiteArrowIcon from "../assets/arrow-right-line copy 4.svg";
import arrowIcon from "../assets/arrow-right-line-save-trip.svg";
import arrowRightLineWhite from "../assets/arrow-right-line-white.svg";
import nextIcon from "../assets/arrow-right-line-white.svg";
import arrowRightSharpLight from "../assets/arrow-right-sharp-light.svg";
import areaIcon from "../assets/arrow-up-right-and-arrow-down-left-from-center-light.svg";
import refineIcon from "../assets/newIcon/refine-icon.svg";
import newBookIconWhite from "../assets/newIcon/new-book-icon-white.svg";
import backIconWithText from "../assets/back-icon-with-text.png";
import backIcon from "../assets/back-icon.svg";
import noSmookingIcon from "../assets/ban-smoking-light.svg";
import bathIcon from "../assets/bath.svg";
import bedWhite from "../assets/bed-fron-white.svg";
import bedFontLightWhite from "../assets/bed-front-light-white.svg";
import bedFontLight from "../assets/bed-front-light.svg";
import redBedIcon from "../assets/bed-front-red.svg";
import bookedSuccesIcon from "../assets/booked-done-icon.png";
import breadCrumbsArrowIcon from "../assets/bread-crumbs-arrow.svg";
import businessCenterIcon from "../assets/briefcase-light.svg";
import cartIcon from "../assets/newIcon/f-cart-icon.svg";
import buyIcon from "../assets/buy-icon.svg";
import cableTvIcon from "../assets/cable-channels-light.svg";
import calendarRangeDark from "../assets/calendar-range-dark.svg";
import calenderRangeLight from "../assets/calendar-range-light.svg";
import calendarRangeRegular from "../assets/calendar-range-regular.svg";
import calenderIcon from "../assets/calender-icon.svg";
import cancelGreyIcon from "../assets/cancel-grey.svg";
import cancelChatReqIcon from "../assets/cancel-request-icon.png";
import carpetedIcon from "../assets/carpet-light.svg";
import checkedIcon from "../assets/checked-icon.svg";
import newBlueCheckIcon from "../assets/circle-check-blue.svg";
import circleCheckIcon from "../assets/circle-check-dark-SM.svg";
import greenCheckIcon from "../assets/circle-check-light.svg";
import travelerInfoCompleteIcon from "../assets/circle-check-traveler.png";
import redInfoIcon from "../assets/circle-info-red-light.svg";
import darkInfoIcon from "../assets/newIcon/info-icon.svg";
import onSiteParkingIcon from "../assets/circle-parking-light.svg";
import newCloseIcon from "../assets/circle-xmark-light-white.svg";
import closeCrossIcon from "../assets/close-line.svg";
import closeWhiteIcon from "../assets/close-white-icon.svg";
import closeBlackIcon from "../assets/closeBlackIcon.svg";
import cloudBoltSunLight from "../assets/cloud-bolt-sun-light med.svg";
import cloudShowers from "../assets/cloud-showers-heavy-light.svg";
import collapseIcon from "../assets/collapse-icon.svg";
import creditCardIcon from "../assets/credit-card-regular.svg";
import deleteIcon from "../assets/delete-bin-6-line.svg";
import deskIcon from "../assets/desk-light.svg";
import dishwasherIcon from "../assets/dishwasher-light.svg";
import dragIcon from "../assets/draggable.svg";
import fitnessCenterIcon from "../assets/dumbbell-light.svg";
import editIcon from "../assets/edit-fill.svg";
import editIconNew from "../assets/edit-icon.svg";
import expandIcon from "../assets/expand-icon.svg";
import eyeLight from "../assets/eye-light.svg";
import flightBed from "../assets/fligh-bed.svg";
import FlightCancelIcon from "../assets/flight-cancel.svg";
import fullscreenIcon from "../assets/fullscreen.svg";
import heatingIcon from "../assets/heating-light.svg";
import hotelDetailsImg from "../assets/hotelPlaceholder.png";
import hotelRoomIcon from "../assets/hotelRoom.png";
import hourglassLight from "../assets/hourglass-half-light.svg";
import hourglassHalfRegular from "../assets/hourglass-half-regular.svg";
import incomingFlightIcon from "../assets/incoming-plane-engines-light.png";
import infoIcon from "../assets/infoIcon-removebg-preview.png";
import kitchennetteIcon from "../assets/kitchenette-light.svg";
import likedIcon from "../assets/like-icon.png";
import locationIcon from "../assets/location-icon-removebg.png";
import newSearchIcon from "../assets/magnifying-glass-light.svg";
import magnifyingGlassRegular from "../assets/magnifying-glass-regular.svg";
// import plateUtensilsLight from "../assets/plate-utensils-light.svg";
import mailIcon from "../assets/mail.svg";
import whiteMenuIcon from "../assets/menuIconWhite.svg";
import micIcon from "../assets/mic-icon.png";
import micIconFig from "../assets/newIcon/f-mic-icon.svg";
import microWaveIcon from "../assets/microwave-light.svg";
import minusIcon from "../assets/minus-light.svg";
import modifyEditIcon from "../assets/modify-edit.png";
import teaMakerIcon from "../assets/mug-hot-light.svg";
import multiCityIcon from "../assets/multi-city-icon.svg";
import newTripWithTextIcon from "../assets/new-trip-with-text.png";
import newExpandIcon from "../assets/newExpandIcon.svg";
import Dollar from "../assets/newIcon/Dollar.svg";
import addGuestIcon from "../assets/newIcon/add-guest-icon.png";
import hotelWhiteIcon from "../assets/newIcon/bed-front-light-white.svg";
import roomImagePlaceholderIcon from "../assets/newIcon/RoomImagePlaceholder.svg";
import clearInputTextIcon from "../assets/newIcon/newCloseIcon.svg";
import additionalCrossIcon from "../assets/newIcon/close-additional-cross-icon.png";
import chatHelpIcon from "../assets/newIcon/comments-question-check-thin.png";
import disableChangeIcon from "../assets/newIcon/disable-change-icon.png";
import emptyCardIcon from "../assets/newIcon/empty-cart-icon.png";
import emailIcon from "../assets/newIcon/envelope-thin.png";
import lockIcon from "../assets/newIcon/lock-icon.png";
import newBackIcon from "../assets/newIcon/new-back-icon.png";
import newBookWiteIcon from "../assets/newIcon/new-book-icon-white.png";
import newBookIcon from "../assets/newIcon/new-book-icon.svg";
import bookIconFig from "../assets/newIcon/f-book-icon.svg";
import bookIconWhiteFig from "../assets/newIcon/f-book-icon-light.svg";
import newEditIcon from "../assets/newIcon/new-edit-icon.svg";
import newMenuIcon from "../assets/newIcon/new-menu-icon.svg";
import newSaveIcon from "../assets/newIcon/new-save-icon.svg";
import sendIcon from "../assets/newIcon/new-send-icon-1.png";
import sendIconFig from "../assets/newIcon/f-send-icon.svg";
import newShareIcon from "../assets/newIcon/new-share-icon.svg";
import newNewTripIcon from "../assets/newIcon/new-trip-icon.png";
import newEmailIcon from "../assets/newIcon/newEmailIcon.svg";
import downloadIcon from "../assets/newIcon/downloadIcon.svg";
import newRightArrowIcon from "../assets/newIcon/newRightArrowIcon.svg";
import phoneIcon from "../assets/newIcon/phone-thin.png";
import planeWhiteIcon from "../assets/newIcon/plane-engines-light-white.svg";
import plateUtensilsLight from "../assets/newIcon/plate-utensils-light.svg";
import additionalPluseIcon from "../assets/newIcon/plus-additional-icon.png";
import promptCalenderIcon from "../assets/newIcon/promptIcon/calender.png";
import promptEarthIcon from "../assets/newIcon/promptIcon/earth.png";
import promptFlightIcon from "../assets/newIcon/promptIcon/flight.png";
import searchWhiteIcon from "../assets/newIcon/search-icon.png";
import newTripIcon from "../assets/newTripIcon.png";
import updatedNewTrip from "../assets/newTripIcon.png";
import newTripLogo from "../assets/newTripIcon.svg";
import notLikedIcon from "../assets/not-like-icon.png";
import outgoingFlightIcon from "../assets/outgoing-plane-engines-light.svg";
import whiteEditIcon from "../assets/pen-to-square-light white.svg";
import peopleIcon from "../assets/peopleIcon.svg";
import personHikingLight from "../assets/person-hiking-light.svg";
import poolIcon from "../assets/person-swimming-light.svg";
import personWalkingLuggage from "../assets/person-walking-luggage-regular.svg";
import personaliseIcon from "../assets/personaliseIcon.svg";
import landLineIcon from "../assets/phone-light.svg";
import planeArrivalLight from "../assets/plane-arrival-light.svg";
import planeArrivalRegular from "../assets/plane-arrival-regular.svg";
import planeDepartureLight from "../assets/plane-departure-light.svg";
import planeDepartureRegularWhite from "../assets/plane-departure-regular-white.svg";
import planeDepartureRegular from "../assets/plane-departure-regular.svg";
import planeEnginesLight from "../assets/plane-engines-light.svg";
import planeEnginesWhite from "../assets/plane-engines-white.svg";
import restaurantIcon from "../assets/plate-utensils-light.svg";
import plusIcon from "../assets/plus-light.svg";
import addIcon from "../assets/plus.svg";
import privateBathroomIcon from "../assets/private-bathroom-light.svg";
import profileIcon from "../assets/profile-icon.svg";
import pullerIcon from "../assets/puller.png";
import radioIcon from "../assets/radio-tuner-light.svg";
import closeIcon from "../assets/red-close-line.svg";
import refridgeratorIcon from "../assets/refrigerator-light.svg";
import roomImg from "../assets/roomImg.png";
import saveIcon from "../assets/save.svg";
import newCabinSeatIcon from "../assets/seat-airline-light.svg";
import seatArlineRegular from "../assets/seat-airline-regular.svg";
import sofaSeatingIcon from "../assets/seating-area-light.svg";
import selectRecentTravelerIcon from "../assets/select-recent-traveler-plus-icon.png";
import selectedIcon from "../assets/selected-icon.svg";
import shareIconWithText from "../assets/share-icon-with-text.png";
import shareIcon from "../assets/share.svg";
import showMoreIcon from "../assets/show-more-icon.svg";
import showerIcon from "../assets/shower-light.svg";
import slidersRegular from "../assets/slidersRegular.svg";
import airConditioningIcon from "../assets/snowflake-light med.svg";
import starSharpSolid from "../assets/star-sharp-solid.svg";
import stopMicIcon from "../assets/stop-mic.svg";
import substractIcon from "../assets/subtract.svg";
import sunLight from "../assets/sun-light.svg";
import swipeLeftTr from "../assets/swipe-left-chevron.svg";
import transparentSwipeRightIcon from "../assets/swipe-right-chevron.svg";
import thumbsDownLightIcon from "../assets/thumbs-down-light-grey.png";
import thumbsDownIcon from "../assets/thumbs-down-light.svg";
import thumbsUpGreyIcon from "../assets/thumbs-up-grey.png";
import thumbsUpIcon from "../assets/thumbs-up-light.svg";
import ticketsAirlineRegular from "../assets/tickets-airline-regular.svg";
import toiletIcon from "../assets/toilet-light.svg";
import freeToileriesIcon from "../assets/toiletries-light.svg";
import televisionIcon from "../assets/tv-light.svg";
import unCheckedIcon from "../assets/unchecked-icon.svg";
import outlinedCircleCloseIcon from "../assets/updateCloseIcon.svg";
import updatedCloseIcon from "../assets/updatedCloseIcon.svg";
import updatedSeeMoreIcon from "../assets/updatedSeeMoreIcon.png";
import personsIcon from "../assets/user-group-light.svg";
import safeDepositIcon from "../assets/vault-light.svg";
import wakeUpServiceIcon from "../assets/wake-up-service-alarm-clock.svg";
import warningIcon from "../assets/warningIcon.png";
import wheelChairIcon from "../assets/wheelchair-accessible-light.svg";
import cancelIcon from "../assets/white-close-line.svg";
import freeWifiIcon from "../assets/wifi-light.svg";
// import backIcon from "../assets/back-icon-new.svg";
import { brand as _brandManifest } from "../branding/generated/brand-manifest";
import { funnelLoginFox, funnelOnboardingFox, funnelMessage, funnelCheck, funnelWordmark } from "./funnelAssets";
import lookingForIcon from "../assets/newIcon/lookingForIcon.svg";
import travelWithIcon from "../assets/newIcon/travelWithIcon.svg";
import enterHomeCity from "../assets/newIcon/enterHomeCity.svg";
import raw44 from "../assets/newIcon/raw44.svg";
import myTripIcon from "../assets/my-trip.svg";
import planeEngineNewLight from "../assets/newIcon/plane-engines-light.svg";
import bedFrontLightNewWhite from "../assets/newIcon/bed-front-light.svg";
import flexibility from "../assets/newIcon/flexibility.svg";
import updatedRightCheckIcon from "../assets/newIcon/circle-check-new.svg";
import redXIcon from "../assets/newIcon/redXIcon.svg";
import chevron_right from "../assets/newIcon/chevron_right.svg";
import CloseIcon from "../assets/newIcon/newCloseIcon.svg";
import NewLocation from "../assets/newIcon/NewLocation.svg";
import SaveIcon from "../assets/newIcon/SaveIcon.svg";
import HistoryIcon from "../assets/newIcon/History.svg";
import PreferenceIcon from "../assets/newIcon/Preference.svg";
import SupportIcon from "../assets/newIcon/Support.svg";
import PrivacyIcon from "../assets/newIcon/PrivacyPolicy.svg";
import termsIcon from "../assets/newIcon/Terms.svg";
import NewGoogleLogo from "../assets/newIcon/NewGoogleLogo.svg";
import emailNewLogo from "../assets/newIcon/emailNewLogo.svg";
import appleNewLogo from "../assets/newIcon/appleNewLogo.svg";
import x3GoogleLogo from "../assets/3xpng/Google_G_Logo.png";
import x3GoogleLogoSign from "../assets/3xpng/Google_G_Logo_signup.png";
import x3AppleLogo from "../assets/3xpng/Apple_Logo.png";
import x3AppleLogoSign from "../assets/3xpng/Apple_Logo_signup.png";
import x3MailLogo from "../assets/3xpng/mail_logo.png";
import x3FacebookLogo from "../assets/3xpng/Facebook_Logo.png";
import x3FacebookLogoSign from "../assets/3xpng/Facebook_Logo_signup.png";
import menuIconFig from "../assets/newIcon/f-menu-icon.svg";
import local_dining from "../assets/newIcon/local_dining.svg";
import newDollarIcon from "../assets/newIcon/attach_money.svg";
import chevronLeftIcon from "../assets/newIcon/chevron_left.svg";
import sideArrowFig from "../assets/newIcon/f-side-arrow.svg";
import onBoardingOnlyStarIcon from "../assets/newIcon/onBoardingOnlyStarIcon.svg";
import planeEnginesDark from "../assets/newIcon/planeEnginesDark.svg";
import logoutIcon from "../assets/newIcon/logoutIcon.svg";
import figMicLLMStopIcon from "../assets/newIcon/f-mic-llm-cancel-new.svg";
import addicon from "../assets/newIcon/add.svg";
import refreshIcon from "../assets/newIcon/refresh.svg";
import HomeLogoOnBoarding from "../assets/pngsvg/Home_2.png";
import checkWhiteIcon from "../assets/newIcon/checkWhiteIcon.svg";
import travelSuiteCase from "../assets/newIcon/travelSuiteCase.svg";
import updatedEditIcon from "../assets/updatedEditIcon.svg";
import visibility from "../assets/newIcon/visibility.svg";
import flightTakeOff from "../assets/newIcon/flight_takeoff.svg";
import rightIcon from "../assets/newIcon/rightIcon.svg";
import swapIcon from "../assets/newIcon/swapIcon.svg";
import dropIcon from "../assets/newIcon/DropIcon.svg";
import gearBlackIcon from "../assets/newIcon/gearBlack.svg";
import personIcon from "../assets/newIcon/person.svg";
import zenvoyaMainIcon from "../assets/newIcon/zenvoya-main-logo.png";
import darkNextIcon from "../assets/newIcon/dark-next-icon.png";
import errorInfo from "../assets/newIcon/errorInfo.svg";
import lock from "../assets/newIcon/locks.svg";
import travelerProfileIcon from "../assets/newIcon/travelerProfileIcon.svg";
import bedWithPersonIcon from "../assets/newIcon/bed-with-person.svg";
import dropdownTickIcon from "../assets/newIcon/dropdown-tick.svg";
import bookingInProgressIcon from "../assets/newIcon/bookingInProgresssIcon.png";
import greenCheckMark from "../assets/newIcon/GreenCheckMark.svg";
import Clock_Icon_18x18 from "../assets/3xpng/Clock_Icon_18x18.png";
import Clock_Icon_20x20 from "../assets/3xpng/Clock_Icon_20x20.png";
import blue_calendar_today_20x20 from "../assets/3xpng/blue_calendar_today_20x20.png";
import blue_check from "../assets/3xpng/blue_check.png";
import blue_person_20x20 from "../assets/3xpng/blue_person_20x20.png";
import language_20x20 from "../assets/3xpng/language_20x20.png";
import person_20x20 from "../assets/3xpng/person_20x20.png";
import inChatHotelResultIcon from "../assets/in-chat-hotel-result.png";
import inChatFlightResultIcon from "../assets/in-chat-flight-result.png";
import { assetOrigin } from "../utils/widgetRuntime";

const _pub = (p: string) => assetOrigin() + import.meta.env.BASE_URL.replace(/\/$/, "") + p;
const zenvolyaNewLogo = _pub(_brandManifest.logo.wordmark);
const loginLogo = funnelLoginFox;
const bookingNavBarLogo = _pub(_brandManifest.logo.booking);
const figFoxActive = _pub(_brandManifest.chatAvatar);
const railMascot = _pub(_brandManifest.sidebarMascot);
const gearPurple = _pub(`${_brandManifest.iconsDir}/gearPurple.svg`);
const modifyPurpleIcon = _pub(`${_brandManifest.iconsDir}/modifyPurpleIcon.svg`);
const sharePurpleIcon = _pub(`${_brandManifest.iconsDir}/sharePurpleIcon.svg`);
const NewPurpleCalendarIcon = _pub(`${_brandManifest.iconsDir}/NewPurpleCalendarIcon.svg`);
const NewEditICon = _pub(`${_brandManifest.iconsDir}/NewEditICon.svg`);
const HomeIcon = _pub(`${_brandManifest.iconsDir}/HomeIcon.svg`);
const starIcon = _pub(`${_brandManifest.iconsDir}/starIcon.svg`);
const newLocationIcon = _pub(`${_brandManifest.iconsDir}/locationIcon.svg`);
const message = funnelMessage;
const check_small = _pub(`${_brandManifest.iconsDir}/check_small.svg`);
const newCheckMark = _pub(`${_brandManifest.iconsDir}/newCheckMark.svg`);
const expandBlueIcon = _pub(`${_brandManifest.iconsDir}/epandIconBlue.svg`);
const homeCityBgImage = _pub(_brandManifest.images.homeBg);
const assistantMark = _pub(_brandManifest.images.assistantMark);
const assistantMarkPassive = _pub(_brandManifest.images.assistantMarkPassive);
const onBoardingFoxIcon = funnelOnboardingFox;
const figAskzoya = _pub(_brandManifest.images.askAssistant);
const supportFoxIcon = _pub(_brandManifest.images.supportMascot);
const onBoardingFoxIconNew = _pub(_brandManifest.images.character);
const assistantLuggageIcon = _pub(_brandManifest.images.assistantLuggage);
const chatLoaderIcon = _pub(_brandManifest.images.chatLoader);
const avatarIcon = _pub(_brandManifest.images.avatar);
const mapFox = _pub(_brandManifest.images.mapFox);
const confirmLogo = _pub(_brandManifest.images.confirmLogo);
const failedLogo = _pub(_brandManifest.images.failedLogo);
const activityUnavailableIcon = _pub(_brandManifest.images.activityUnavailable);
const supportIcon = _pub(_brandManifest.images.supportIcon);
const activityHelpIcon = _pub(_brandManifest.images.activityHelp);
const ticketIcon = _pub(`${_brandManifest.iconsDir}/ticket.svg`);
const stopMicIconFig = _pub(`${_brandManifest.iconsDir}/f-mic-stop.svg`);
const budgetLogo = raw44;

export {
  funnelCheck,
  funnelWordmark,
  inChatHotelResultIcon,
  inChatFlightResultIcon,
  greenCheckMark,
  bookingInProgressIcon,
  dropdownTickIcon,
  bookingNavBarLogo,
  bedWithPersonIcon,
  modifyPurpleIcon,
  sharePurpleIcon,
  expandBlueIcon,
  travelerProfileIcon,
  lock,
  NewEditICon,
  supportIcon,
  NewPurpleCalendarIcon,
  newLocationIcon,
  darkNextIcon,
  zenvoyaMainIcon,
  supportFoxIcon,
  errorInfo,
  newBookIconWhite,
  refineIcon,
  personIcon,
  gearPurple,
  gearBlackIcon,
  starIcon,
  dropIcon,
  HomeIcon,
  swapIcon,
  rightIcon,
  flightTakeOff,
  visibility,
  figAskzoya,
  onBoardingFoxIcon,
  updatedEditIcon,
  travelSuiteCase,
  assistantMark,
  figFoxActive,
  railMascot,
  assistantMarkPassive,
  homeCityBgImage,
  checkWhiteIcon,
  HomeLogoOnBoarding,
  addicon,
  refreshIcon,
  logoutIcon,
  planeEnginesDark,
  budgetLogo,
  lookingForIcon,
  travelWithIcon,
  message,
  onBoardingOnlyStarIcon,
  figMicLLMStopIcon,
  enterHomeCity,
  sideArrowFig,
  chevronLeftIcon,
  newDollarIcon,
  local_dining,
  newCheckMark,
  sendIconFig,
  ticketIcon,
  assistantLuggageIcon,
  chatLoaderIcon,
  mapFox,
  confirmLogo,
  failedLogo,
  activityUnavailableIcon,
  activityHelpIcon,
  emailNewLogo,
  appleNewLogo,
  loginLogo,
  NewGoogleLogo,
  x3GoogleLogo,
  x3GoogleLogoSign,
  x3AppleLogo,
  x3AppleLogoSign,
  x3MailLogo,
  x3FacebookLogo,
  x3FacebookLogoSign,
  termsIcon,
  NewLocation,
  SaveIcon,
  HistoryIcon,
  PreferenceIcon,
  SupportIcon,
  PrivacyIcon,
  CloseIcon,
  check_small,
  raw44,
  chevron_right,
  redXIcon,
  updatedRightCheckIcon,
  planeEngineNewLight,
  bedFrontLightNewWhite,
  flexibility,
  myTripIcon,
  Dollar,
  emailIcon,
  chatHelpIcon,
  phoneIcon,
  newRightArrowIcon,
  cancelChatReqIcon,
  lockIcon,
  emptyCardIcon,
  newEmailIcon,
  downloadIcon,
  additionalCrossIcon,
  additionalPluseIcon,
  searchWhiteIcon,
  planeWhiteIcon,
  hotelWhiteIcon,
  disableChangeIcon,
  addGuestIcon,
  newBackIcon,
  promptEarthIcon,
  promptFlightIcon,
  promptCalenderIcon,
  newCabinSeatIcon,
  clearInputTextIcon,
  newNewTripIcon,
  newMenuIcon,
  newExpandIcon,
  peopleIcon,
  boldDownWardIcon,
  newBookWiteIcon,
  newSaveIcon,
  newShareIcon,
  newEditIcon,
  newBookIcon,
  bookIconFig,
  bookIconWhiteFig,
  menuIconFig,
  closeBlackIcon,
  warningIcon,
  mailIcon,
  nextIcon,
  personHikingLight,
  plateUtensilsLight,
  thumbsUpGreyIcon,
  pullerIcon,
  bedFontLightWhite,
  newTripWithTextIcon,
  thumbsDownLightIcon,
  travelerInfoCompleteIcon,
  circleRightIcon,
  planeArrivalLight,
  redInfoIcon,
  darkInfoIcon,
  newSearchIcon,
  selectRecentTravelerIcon,
  greenCheckIcon,
  arrowRightSharpLight,
  newBlueCheckIcon,
  breadCrumbsArrowIcon,
  circleCheckIcon,
  searchGrayIcon,
  backIconWithText,
  shareIconWithText,
  addNewIcon,
  cancelGreyIcon,
  outgoingFlightIcon,
  incomingFlightIcon,
  failureOvalIcon,
  avatarIcon,
  creditCardIcon,
  appleIcon,
  redBedIcon,
  thumbsDownIcon,
  thumbsUpIcon,
  hotelRoomIcon,
  whiteArrowIcon,
  whiteEditIcon,
  greenOutlinedTickMark,
  propertyAmenitiesImg,
  roomImg,
  hotelDetailsImg,
  carpetedIcon,
  microWaveIcon,
  deskIcon,
  wheelChairIcon,
  radioIcon,
  sofaSeatingIcon,
  privateBathroomIcon,
  wakeUpServiceIcon,
  kitchennetteIcon,
  freeToileriesIcon,
  dishwasherIcon,
  toiletIcon,
  cableTvIcon,
  heatingIcon,
  bathIcon,
  refridgeratorIcon,
  teaMakerIcon,
  landLineIcon,
  televisionIcon,
  showerIcon,
  safeDepositIcon,
  areaIcon,
  personsIcon,
  outlinedCircleCloseIcon,
  freeWifiIcon,
  airConditioningIcon,
  restaurantIcon,
  poolIcon,
  fitnessCenterIcon,
  onSiteParkingIcon,
  businessCenterIcon,
  noSmookingIcon,
  swipeLeftTr,
  transparentSwipeRightIcon,
  sendIcon,
  micIcon,
  micIconFig,
  stopMicIcon,
  stopMicIconFig,
  profileIcon,
  editIcon,
  showMoreIcon,
  likedIcon,
  notLikedIcon,
  locationIcon,
  selectedIcon,
  cancelIcon,
  leftLineArrowIcon,
  leftLineArrowGreyIcon,
  checkedIcon,
  unCheckedIcon,
  closeCrossIcon,
  closeWhiteIcon,
  infoIcon,
  dragIcon,
  addIcon,
  substractIcon,
  deleteIcon,
  saveIcon,
  closeIcon,
  arrowNextIcon,
  shareIcon,
  buyIcon,
  cartIcon,
  multiCityIcon,
  newTripIcon,
  calenderIcon,
  arrowIcon,
  newTripLogo,
  slidersRegular,
  personaliseIcon,
  calendarRangeRegular,
  collapseIcon,
  backIcon,
  modifyEditIcon,
  zenvolyaNewLogo,
  expandIcon,
  updatedNewTrip,
  bedFontLight,
  planeEnginesLight,
  flightBed,
  updatedSeeMoreIcon,
  updatedCloseIcon,
  magnifyingGlassRegular,
  arrowRightArrowLeftRegular,
  minusIcon,
  plusIcon,
  eyeLight,
  bedWhite,
  planeEnginesWhite,
  sunLight,
  cloudShowers,
  cloudBoltSunLight,
  arrowRight,
  personWalkingLuggage,
  bookedSuccesIcon,
  arrowRightLineWhite,
  whiteMenuIcon,
  planeDepartureRegular,
  FlightCancelIcon,
  seatArlineRegular,
  planeArrivalRegular,
  hourglassHalfRegular,
  ticketsAirlineRegular,
  calendarRangeDark,
  planeDepartureRegularWhite,
  starSharpSolid,
  calenderRangeLight,
  hourglassLight,
  PathIcon,
  newCloseIcon,
  planeDepartureLight,
  fullscreenIcon,
  editIconNew,
  onBoardingFoxIconNew,
  Clock_Icon_18x18,
  Clock_Icon_20x20,
  blue_calendar_today_20x20,
  blue_check,
  blue_person_20x20,
  language_20x20,
  person_20x20,
  roomImagePlaceholderIcon,
};

/**
 * The icons above drawn in one dark colour, which Theme Studio repaints with the
 * partner's Icons colour (constant/neutralIcons.ts → the `zv-icon` class). Add an
 * icon here when it is a single dark colour shown on a page, card, field or menu.
 */
export const NEUTRAL_ICON_SRCS: string[] = [
  CloseIcon, HistoryIcon, NewLocation, PathIcon, PreferenceIcon, PrivacyIcon, SaveIcon, SupportIcon, addIcon,
  addicon, areaIcon, arrowIcon, arrowRight, arrowRightArrowLeftRegular, arrowRightSharpLight, backIcon,
  bedFontLight, bedFontLightWhite, bedWithPersonIcon, boldDownWardIcon, bookIconFig, buyIcon,
  calendarRangeDark, calendarRangeRegular, calenderIcon, calenderRangeLight, cancelGreyIcon, cartIcon,
  chevronLeftIcon, circleCheckIcon, circleRightIcon, clearInputTextIcon, closeBlackIcon, closeCrossIcon,
  closeWhiteIcon, cloudShowers, collapseIcon, creditCardIcon, darkInfoIcon, deleteIcon, downloadIcon,
  dragIcon, dropIcon, dropdownTickIcon, editIcon, editIconNew, expandIcon, eyeLight, failureOvalIcon,
  flexibility, flightBed, flightTakeOff, hourglassHalfRegular, hourglassLight, local_dining, lock,
  logoutIcon, magnifyingGlassRegular, menuIconFig, micIconFig, minusIcon, myTripIcon, newBookIcon,
  newCabinSeatIcon, newCloseIcon, newDollarIcon, newEditIcon, newEmailIcon, newExpandIcon, newMenuIcon,
  newSaveIcon, newShareIcon, outgoingFlightIcon, peopleIcon, personHikingLight, personIcon,
  personWalkingLuggage, personaliseIcon, personsIcon, planeArrivalLight, planeArrivalRegular,
  planeDepartureLight, planeDepartureRegular, planeEnginesDark, planeEnginesLight, plateUtensilsLight,
  plusIcon, refineIcon, refreshIcon, rightIcon, saveIcon, searchGrayIcon, seatArlineRegular, shareIcon,
  showMoreIcon, sideArrowFig, slidersRegular, substractIcon, sunLight, swapIcon, termsIcon,
  ticketsAirlineRegular, travelSuiteCase, travelerProfileIcon, updatedEditIcon, visibility,
];
